/**
 * This file is auto-generated: common models & enums
 */

export enum OpsiumUserResponseConnectedIntegrations {
  Google = 'GOOGLE',
  Jira = 'JIRA',
  QuickBooks = 'QUICK_BOOKS',
  Unknown = 'UNKNOWN',
}

export enum OpsiumUserResponseIgnoredIntegrations {
  Google = 'GOOGLE',
  Jira = 'JIRA',
  QuickBooks = 'QUICK_BOOKS',
  Unknown = 'UNKNOWN',
}

export enum UpdateOpsiumUserRequestItemIgnoredIntegrations {
  Google = 'GOOGLE',
  Jira = 'JIRA',
  QuickBooks = 'QUICK_BOOKS',
  Unknown = 'UNKNOWN',
}

export enum DeleteOpsiumUsersBulkResponseStatus {
  Success = 'SUCCESS',
  Failed = 'FAILED',
  SomeFailed = 'SOME_FAILED',
}

export enum IntegrationToUseRequestIntegration {
  Google = 'GOOGLE',
  Jira = 'JIRA',
  QuickBooks = 'QUICK_BOOKS',
  Unknown = 'UNKNOWN',
}

export enum EntityValidationErrorResponseErrorCode {
  DuplicateEntitiesExists = 'DUPLICATE_ENTITIES_EXISTS',
  EntitiesWithErrorsExist = 'ENTITIES_WITH_ERRORS_EXIST',
}

export enum CsvImportUserErrorErrorFields {
  Name = 'NAME',
  Email = 'EMAIL',
}

export enum OrganizationDefaultsResponseProjectRateSource {
  Flat = 'FLAT',
  User = 'USER',
  Seniority = 'SENIORITY',
  Role = 'ROLE',
  Organization = 'ORGANIZATION',
  RateCard = 'RATE_CARD',
}

export enum OrganizationDefaultsResponseUseRateSourceOnProject {
  Flat = 'FLAT',
  Custom = 'CUSTOM',
  User = 'USER',
  Seniority = 'SENIORITY',
  Role = 'ROLE',
  Organization = 'ORGANIZATION',
}

export enum OrganizationDefaultsResponseAssignmentRateSource {
  Project = 'PROJECT',
  User = 'USER',
  Seniority = 'SENIORITY',
  Role = 'ROLE',
  Organization = 'ORGANIZATION',
  Custom = 'CUSTOM',
}

export enum OnboardingStateResponseFlow {
  OrganizationOnboarding = 'ORGANIZATION_ONBOARDING',
  Unknown = 'UNKNOWN',
}

export enum PreviewClientResponseDefaultPaymentTerms {
  Net7 = 'NET_7',
  Net15 = 'NET_15',
  Net30 = 'NET_30',
  Net45 = 'NET_45',
  Net60 = 'NET_60',
  Net90 = 'NET_90',
  EndOfMonth = 'EOM',
  CashInAdvance = 'CIA',
  CashOnDelivery = 'COD',
  CashWithOrder = 'CWO',
}

export enum PreviewClientResponseConnectedIntegrations {
  Google = 'GOOGLE',
  Jira = 'JIRA',
  QuickBooks = 'QUICK_BOOKS',
  Unknown = 'UNKNOWN',
}

export enum CsvImportClientErrorErrorFields {
  Name = 'NAME',
}

export enum CreateIntegrationInfoRequestIntegrationProviderType {
  Google = 'GOOGLE',
  Jira = 'JIRA',
  QuickBooks = 'QUICK_BOOKS',
  Unknown = 'UNKNOWN',
}

export enum ProjectResponseConnectedIntegrations {
  Google = 'GOOGLE',
  Jira = 'JIRA',
  QuickBooks = 'QUICK_BOOKS',
  Unknown = 'UNKNOWN',
}

export enum ProjectResponseIgnoredIntegrations {
  Google = 'GOOGLE',
  Jira = 'JIRA',
  QuickBooks = 'QUICK_BOOKS',
  Unknown = 'UNKNOWN',
}

export enum ProjectSummaryResponseStatus {
  Tentative = 'TENTATIVE',
  Active = 'ACTIVE',
  Archived = 'ARCHIVED',
}

export enum ProjectSummaryResponseBillingModel {
  FixedPrice = 'FIXED_PRICE',
  TimeAndMaterials = 'TIME_AND_MATERIALS',
  NonBillable = 'NON_BILLABLE',
}

export enum ProjectSummaryResponseConnectedIntegrations {
  Google = 'GOOGLE',
  Jira = 'JIRA',
  QuickBooks = 'QUICK_BOOKS',
  Unknown = 'UNKNOWN',
}

export enum FindProjectSummariesFilterRequestStatus {
  Tentative = 'TENTATIVE',
  Active = 'ACTIVE',
  Archived = 'ARCHIVED',
}

export enum FindProjectSummariesFilterRequestBillingModel {
  FixedPrice = 'FIXED_PRICE',
  TimeAndMaterials = 'TIME_AND_MATERIALS',
  NonBillable = 'NON_BILLABLE',
}

export enum UpdateProjectBulkItemRequestIgnoredIntegrations {
  Google = 'GOOGLE',
  Jira = 'JIRA',
  QuickBooks = 'QUICK_BOOKS',
  Unknown = 'UNKNOWN',
}

export enum CsvImportProjectErrorErrorFields {
  Name = 'NAME',
  Client = 'CLIENT',
}

export enum CustomAttributeResponseType {
  String = 'STRING',
  Number = 'NUMBER',
  Boolean = 'BOOLEAN',
  Date = 'DATE',
  Singleselect = 'SINGLESELECT',
  Multiselect = 'MULTISELECT',
}

export enum CustomAttributeResponseEntityType {
  User = 'USER',
  Project = 'PROJECT',
  Client = 'CLIENT',
  Invoice = 'INVOICE',
}

export enum ProjectInfoResponseStatus {
  Tentative = 'TENTATIVE',
  Active = 'ACTIVE',
  Archived = 'ARCHIVED',
}

export enum UserRateOptionResponseSource {
  User = 'USER',
  Seniority = 'SENIORITY',
  Role = 'ROLE',
  Organization = 'ORGANIZATION',
}

export enum UserRateOnProjectResponseRateSource {
  Flat = 'FLAT',
  Custom = 'CUSTOM',
  User = 'USER',
  Seniority = 'SENIORITY',
  Role = 'ROLE',
  Organization = 'ORGANIZATION',
}

export enum ProjectBillingResponseBillingModel {
  FixedPrice = 'FIXED_PRICE',
  TimeAndMaterials = 'TIME_AND_MATERIALS',
  NonBillable = 'NON_BILLABLE',
}

export enum ProjectBillingResponseRateSource {
  Flat = 'FLAT',
  User = 'USER',
  Seniority = 'SENIORITY',
  Role = 'ROLE',
  Organization = 'ORGANIZATION',
  RateCard = 'RATE_CARD',
}

export enum IntegrationInfoResponseIntegrationProviderType {
  Google = 'GOOGLE',
  Jira = 'JIRA',
  QuickBooks = 'QUICK_BOOKS',
  Unknown = 'UNKNOWN',
}

export enum CreateProjectInfoChangeRequestStatus {
  Tentative = 'TENTATIVE',
  Active = 'ACTIVE',
  Archived = 'ARCHIVED',
}

export enum CreateUserRateOnProjectRequestRateSource {
  Flat = 'FLAT',
  Custom = 'CUSTOM',
  User = 'USER',
  Seniority = 'SENIORITY',
  Role = 'ROLE',
  Organization = 'ORGANIZATION',
}

export enum CreateProjectBillingChangeRequestBillingModel {
  FixedPrice = 'FIXED_PRICE',
  TimeAndMaterials = 'TIME_AND_MATERIALS',
  NonBillable = 'NON_BILLABLE',
}

export enum CreateProjectBillingChangeRequestRateSource {
  Flat = 'FLAT',
  User = 'USER',
  Seniority = 'SENIORITY',
  Role = 'ROLE',
  Organization = 'ORGANIZATION',
  RateCard = 'RATE_CARD',
}

export enum ProjectInfoVersionedFieldsResponseStatus {
  Tentative = 'TENTATIVE',
  Active = 'ACTIVE',
  Archived = 'ARCHIVED',
}

export enum PatchEntityEffectAction {
  Delete = 'DELETE',
  Cut = 'CUT',
}

export enum ShortProjectResponseStatus {
  Tentative = 'TENTATIVE',
  Active = 'ACTIVE',
  Archived = 'ARCHIVED',
}

export enum FindShortProjectsFilterRequestStatus {
  Tentative = 'TENTATIVE',
  Active = 'ACTIVE',
  Archived = 'ARCHIVED',
}

export enum ProjectChangedFieldResponseFieldName {
  Status = 'STATUS',
  TentativeProbability = 'TENTATIVE_PROBABILITY',
  ManagerUser = 'MANAGER_USER',
  ProjectStartDate = 'PROJECT_START_DATE',
  ProjectEndDate = 'PROJECT_END_DATE',
  Industries = 'INDUSTRIES',
  CustomAttributes = 'CUSTOM_ATTRIBUTES',
  BillingModel = 'BILLING_MODEL',
  DefaultCurrencyCode = 'DEFAULT_CURRENCY_CODE',
  Budget = 'BUDGET',
  RateSource = 'RATE_SOURCE',
  FlatRate = 'FLAT_RATE',
  UserRates = 'USER_RATES',
  UserCustomRate = 'USER_CUSTOM_RATE',
  UserRateSource = 'USER_RATE_SOURCE',
  Google = 'GOOGLE',
  Jira = 'JIRA',
  QuickBooks = 'QUICK_BOOKS',
  Unknown = 'UNKNOWN',
}

export enum ProjectChangedFieldResponseOldValueKey {
  Flat = 'FLAT',
  Custom = 'CUSTOM',
  User = 'USER',
  Seniority = 'SENIORITY',
  Role = 'ROLE',
  Organization = 'ORGANIZATION',
  RateCard = 'RATE_CARD',
  FixedPrice = 'FIXED_PRICE',
  TimeAndMaterials = 'TIME_AND_MATERIALS',
  NonBillable = 'NON_BILLABLE',
  Unknown = 'UNKNOWN',
  Active = 'ACTIVE',
  Archived = 'ARCHIVED',
  Tentative = 'TENTATIVE',
}

export enum ProjectChangedFieldResponseNewValueKey {
  Flat = 'FLAT',
  Custom = 'CUSTOM',
  User = 'USER',
  Seniority = 'SENIORITY',
  Role = 'ROLE',
  Organization = 'ORGANIZATION',
  RateCard = 'RATE_CARD',
  FixedPrice = 'FIXED_PRICE',
  TimeAndMaterials = 'TIME_AND_MATERIALS',
  NonBillable = 'NON_BILLABLE',
  Unknown = 'UNKNOWN',
  Active = 'ACTIVE',
  Archived = 'ARCHIVED',
  Tentative = 'TENTATIVE',
}

export enum ProjectChangeMetadataResponseChangedByIntegration {
  Google = 'GOOGLE',
  Jira = 'JIRA',
  QuickBooks = 'QUICK_BOOKS',
  Unknown = 'UNKNOWN',
}

export enum ProjectChangeMetadataResponseSection {
  Info = 'INFO',
  Billing = 'BILLING',
  Integrations = 'INTEGRATIONS',
}

export enum ProjectChangeMetadataResponseAllowedActions {
  View = 'VIEW',
  Edit = 'EDIT',
  Delete = 'DELETE',
}

export enum ProjectChangesOrderOrderBy {
  ChangedSection = 'CHANGED_SECTION',
  EffectiveDate = 'EFFECTIVE_DATE',
  ChangedBy = 'CHANGED_BY',
}

export enum ProjectChangesOrderOrderDirection {
  Asc = 'ASC',
  Desc = 'DESC',
}

export enum InvoiceHoursSourceResponseSourceType {
  Tracked = 'TRACKED',
  Booked = 'BOOKED',
  Capacity = 'CAPACITY',
}

export enum CreateInvoiceItemRequestDtoEntityType {
  User = 'USER',
}

export enum TeamMembersOrderByOrder {
  Asc = 'asc',
  Desc = 'desc',
}

export enum FindShortTeamMembersFilterRequestStatuses {
  Active = 'ACTIVE',
  Invited = 'INVITED',
  InviteExpired = 'INVITE_EXPIRED',
  Basic = 'BASIC',
  Archived = 'ARCHIVED',
  Placeholder = 'PLACEHOLDER',
}

export enum ProjectBasedRateOptionResponseSource {
  Flat = 'FLAT',
  Custom = 'CUSTOM',
  User = 'USER',
  Seniority = 'SENIORITY',
  Role = 'ROLE',
  Organization = 'ORGANIZATION',
}

export enum TeamMemberInfoResponseInvitationStatus {
  NotInvited = 'NOT_INVITED',
  Sent = 'SENT',
  Expired = 'EXPIRED',
  Accepted = 'ACCEPTED',
}

export enum TeamMemberInfoResponseType {
  RegularMember = 'REGULAR_MEMBER',
  Placeholder = 'PLACEHOLDER',
}

export enum TeamMemberInfoResponseStatus {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED',
}

export enum TeamMemberFullResponseDisplayStatus {
  Active = 'ACTIVE',
  Invited = 'INVITED',
  InviteExpired = 'INVITE_EXPIRED',
  Basic = 'BASIC',
  Archived = 'ARCHIVED',
  Placeholder = 'PLACEHOLDER',
}

export enum TeamMemberUserGroupResponseStatus {
  Active = 'ACTIVE',
  Invited = 'INVITED',
  InviteExpired = 'INVITE_EXPIRED',
  Basic = 'BASIC',
  Archived = 'ARCHIVED',
  Placeholder = 'PLACEHOLDER',
}

export enum TeamMemberChangeMetadataResponseChangedByIntegration {
  Google = 'GOOGLE',
  Jira = 'JIRA',
  QuickBooks = 'QUICK_BOOKS',
  Unknown = 'UNKNOWN',
}

export enum TeamMemberChangeMetadataResponseSection {
  Info = 'INFO',
  Billing = 'BILLING',
  Capacity = 'CAPACITY',
  Integrations = 'INTEGRATIONS',
}

export enum TeamMemberChangedFieldResponseFieldName {
  Status = 'STATUS',
  Department = 'DEPARTMENT',
  Role = 'ROLE',
  Seniority = 'SENIORITY',
  Location = 'LOCATION',
  Manager = 'MANAGER',
  IsManager = 'IS_MANAGER',
  Capacity = 'CAPACITY',
  OnDemand = 'ON_DEMAND',
  InternalRate = 'INTERNAL_RATE',
  ExternalRate = 'EXTERNAL_RATE',
  IsHourlyRated = 'IS_HOURLY_RATED',
  Currency = 'CURRENCY',
}

export enum TeamMemberChangedFieldResponseOldValueKey {}

export enum TeamMemberChangedFieldResponseNewValueKey {}

export enum PlannerUserStateChangeResponseDisplayStatus {
  Active = 'ACTIVE',
  Invited = 'INVITED',
  InviteExpired = 'INVITE_EXPIRED',
  Basic = 'BASIC',
  Archived = 'ARCHIVED',
  Placeholder = 'PLACEHOLDER',
}

export enum AssignmentResponseStatus {
  Confirmed = 'CONFIRMED',
  Unconfirmed = 'UNCONFIRMED',
  Draft = 'DRAFT',
}

export enum AssignmentResponseRateSource {
  Project = 'PROJECT',
  User = 'USER',
  Seniority = 'SENIORITY',
  Role = 'ROLE',
  Organization = 'ORGANIZATION',
  Custom = 'CUSTOM',
}

export enum GetAssignmentsForPlannerFiltersStatuses {
  Confirmed = 'CONFIRMED',
  Unconfirmed = 'UNCONFIRMED',
  Draft = 'DRAFT',
}

export enum GetAssignmentsForPlannerFiltersProjectStatuses {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED',
  Tentative = 'TENTATIVE',
}

export enum AvailableSettingTypesResponseTypes {
  UserProfile = 'USER_PROFILE',
  UserPassword = 'USER_PASSWORD',
  OrganizationDepartments = 'ORGANIZATION_DEPARTMENTS',
  OrganizationSeniorities = 'ORGANIZATION_SENIORITIES',
  OrganizationRoles = 'ORGANIZATION_ROLES',
  OrganizationGeneralSettings = 'ORGANIZATION_GENERAL_SETTINGS',
  OrganizationExternalRates = 'ORGANIZATION_EXTERNAL_RATES',
  OrganizationTimeOff = 'ORGANIZATION_TIME_OFF',
  OrganizationIntegration = 'ORGANIZATION_INTEGRATION',
  OrganizationApi = 'ORGANIZATION_API',
  OrganizationProjectCustomAttributes = 'ORGANIZATION_PROJECT_CUSTOM_ATTRIBUTES',
  OrganizationTags = 'ORGANIZATION_TAGS',
  OrganizationPermissions = 'ORGANIZATION_PERMISSIONS',
  OrganizationMembersAccess = 'ORGANIZATION_MEMBERS_ACCESS',
}

export enum OpsiumUserGroupPoliciesResponsePolicies {
  Fullaccess = 'FullAccess',
  Assignmentsviewown = 'AssignmentsViewOwn',
  Assignmentsviewall = 'AssignmentsViewAll',
  Assignmentscreate = 'AssignmentsCreate',
  Assignmentsedit = 'AssignmentsEdit',
  Assignmentsdelete = 'AssignmentsDelete',
  Teammembersviewall = 'TeamMembersViewAll',
  Teammemberscreate = 'TeamMembersCreate',
  Teammembersedit = 'TeamMembersEdit',
  Teammembersdelete = 'TeamMembersDelete',
  Accessgrantandrevoke = 'AccessGrantAndRevoke',
  Externalratesmanage = 'ExternalRatesManage',
  Internalratesmanage = 'InternalRatesManage',
  Projectsviewall = 'ProjectsViewAll',
  Projectscreate = 'ProjectsCreate',
  Projectsedit = 'ProjectsEdit',
  Projectsdelete = 'ProjectsDelete',
  Clientsviewall = 'ClientsViewAll',
  Clientscreate = 'ClientsCreate',
  Clientsedit = 'ClientsEdit',
  Clientsdelete = 'ClientsDelete',
  Invoicesandbillsview = 'InvoicesAndBillsView',
  Invoicesandbillsgenerate = 'InvoicesAndBillsGenerate',
  Invoicesandbillsdelete = 'InvoicesAndBillsDelete',
  Companyfinancereportview = 'CompanyFinanceReportView',
  Profitabilityandtimetrackingreport = 'ProfitabilityAndTimeTrackingReport',
  Profitabilityandtimetrackingreportlimited = 'ProfitabilityAndTimeTrackingReportLimited',
  Utilizationreportview = 'UtilizationReportView',
  Utilizationreportviewlimited = 'UtilizationReportViewLimited',
  Personalaccountviewandedit = 'PersonalAccountViewAndEdit',
  Orgstructureviewandedit = 'OrgStructureViewAndEdit',
  Orgsettingsmanage = 'OrgSettingsManage',
  Integrationsmanage = 'IntegrationsManage',
  Accessandpermissionsmanage = 'AccessAndPermissionsManage',
}

export enum UpdateUserGroupPoliciesRequestItemPolicies {
  Fullaccess = 'FullAccess',
  Assignmentsviewown = 'AssignmentsViewOwn',
  Assignmentsviewall = 'AssignmentsViewAll',
  Assignmentscreate = 'AssignmentsCreate',
  Assignmentsedit = 'AssignmentsEdit',
  Assignmentsdelete = 'AssignmentsDelete',
  Teammembersviewall = 'TeamMembersViewAll',
  Teammemberscreate = 'TeamMembersCreate',
  Teammembersedit = 'TeamMembersEdit',
  Teammembersdelete = 'TeamMembersDelete',
  Accessgrantandrevoke = 'AccessGrantAndRevoke',
  Externalratesmanage = 'ExternalRatesManage',
  Internalratesmanage = 'InternalRatesManage',
  Projectsviewall = 'ProjectsViewAll',
  Projectscreate = 'ProjectsCreate',
  Projectsedit = 'ProjectsEdit',
  Projectsdelete = 'ProjectsDelete',
  Clientsviewall = 'ClientsViewAll',
  Clientscreate = 'ClientsCreate',
  Clientsedit = 'ClientsEdit',
  Clientsdelete = 'ClientsDelete',
  Invoicesandbillsview = 'InvoicesAndBillsView',
  Invoicesandbillsgenerate = 'InvoicesAndBillsGenerate',
  Invoicesandbillsdelete = 'InvoicesAndBillsDelete',
  Companyfinancereportview = 'CompanyFinanceReportView',
  Profitabilityandtimetrackingreport = 'ProfitabilityAndTimeTrackingReport',
  Profitabilityandtimetrackingreportlimited = 'ProfitabilityAndTimeTrackingReportLimited',
  Utilizationreportview = 'UtilizationReportView',
  Utilizationreportviewlimited = 'UtilizationReportViewLimited',
  Personalaccountviewandedit = 'PersonalAccountViewAndEdit',
  Orgstructureviewandedit = 'OrgStructureViewAndEdit',
  Orgsettingsmanage = 'OrgSettingsManage',
  Integrationsmanage = 'IntegrationsManage',
  Accessandpermissionsmanage = 'AccessAndPermissionsManage',
}

export enum IntegrationLinksResponseIntegration {
  Google = 'GOOGLE',
  Jira = 'JIRA',
  QuickBooks = 'QUICK_BOOKS',
  Unknown = 'UNKNOWN',
}

export enum PatchOrganizationExternalRatesRequestDefaultProjectRateSource {
  Organization = 'ORGANIZATION',
  User = 'USER',
  Seniority = 'SENIORITY',
  Role = 'ROLE',
}

export enum CreateClientRequestDefaultPaymentTerms {
  Net7 = 'NET_7',
  Net15 = 'NET_15',
  Net30 = 'NET_30',
  Net45 = 'NET_45',
  Net60 = 'NET_60',
  Net90 = 'NET_90',
  EndOfMonth = 'EOM',
  CashInAdvance = 'CIA',
  CashOnDelivery = 'COD',
  CashWithOrder = 'CWO',
}

export enum UpdateClientRequestDefaultPaymentTerms {
  Net7 = 'NET_7',
  Net15 = 'NET_15',
  Net30 = 'NET_30',
  Net45 = 'NET_45',
  Net60 = 'NET_60',
  Net90 = 'NET_90',
  EndOfMonth = 'EOM',
  CashInAdvance = 'CIA',
  CashOnDelivery = 'COD',
  CashWithOrder = 'CWO',
}

export enum GetProjectChangesHistoryRequestChangedSection {
  Info = 'INFO',
  Billing = 'BILLING',
  Integrations = 'INTEGRATIONS',
}

export enum DeleteProjectChangeRequestSection {
  Info = 'INFO',
  Billing = 'BILLING',
}

export enum DeleteProjectChangeRequestExtendDirection {
  Next = 'NEXT',
  Previous = 'PREVIOUS',
}

export enum GetTeamMembersRequestStatuses {
  Active = 'ACTIVE',
  Invited = 'INVITED',
  InviteExpired = 'INVITE_EXPIRED',
  Basic = 'BASIC',
  Archived = 'ARCHIVED',
  Placeholder = 'PLACEHOLDER',
}

export enum UpdateTeamMemberInfoRequestType {
  RegularMember = 'REGULAR_MEMBER',
  Placeholder = 'PLACEHOLDER',
}

export enum GetTeamMemberChangesRequestSections {
  Info = 'INFO',
  Billing = 'BILLING',
  Capacity = 'CAPACITY',
  Integrations = 'INTEGRATIONS',
}

export enum DeleteTeamMemberChangeRequestSection {
  Info = 'INFO',
  Billing = 'BILLING',
  Capacity = 'CAPACITY',
  Integrations = 'INTEGRATIONS',
}

export enum DeleteTeamMemberChangeRequestPeriod {
  Previous = 'PREVIOUS',
  Next = 'NEXT',
}

export enum CreateAssignmentRequestStatus {
  Confirmed = 'CONFIRMED',
  Unconfirmed = 'UNCONFIRMED',
  Draft = 'DRAFT',
}

export enum CreateAssignmentRequestRateSource {
  Project = 'PROJECT',
  User = 'USER',
  Seniority = 'SENIORITY',
  Role = 'ROLE',
  Organization = 'ORGANIZATION',
  Custom = 'CUSTOM',
}

export enum UpdateAssignmentRequestStatus {
  Confirmed = 'CONFIRMED',
  Unconfirmed = 'UNCONFIRMED',
  Draft = 'DRAFT',
}

export interface AnnotatedHttpErrorResponse {
  status: number;
  message: string;
  code?: number;
  args?: string[];
}

export interface ApiResponse {
  [key: string]: any;
}

export interface PaginatedMetadataResponse {
  page?: number;
  cursor?: any;
  total: number;
}

export interface GetIndustriesResponse {
  industries: string[];
}

export interface GetHealthResponse {
  ok: boolean;
}

export interface OpsiumUserResponse {
  id: number;
  email: string;
  name: string;
  importedFromFilename?: string;
  connectedIntegrations: OpsiumUserResponseConnectedIntegrations[];
  ignoredIntegrations: OpsiumUserResponseIgnoredIntegrations[];
}

export interface InsertOpsiumUserRequestItem {
  email: string;
  name: string;
}

export interface UpdateOpsiumUserRequestItem {
  id: number;
  email: string;
  name: string;
  ignoredIntegrations?: UpdateOpsiumUserRequestItemIgnoredIntegrations[];
}

export interface UserFailedToDelete {
  id: number;
  name: string;
  email: string | null;
}

export interface DeleteOpsiumUsersBulkResponse {
  status: DeleteOpsiumUsersBulkResponseStatus;
  failed: UserFailedToDelete[];
}

export interface EntityValidationReportResponse {
  total: number;
  errorsCount: number;
  duplicatesCount: number;
  warningsCount: number;
}

export interface IntegrationToUseRequest {
  integration: IntegrationToUseRequestIntegration;
  sourceUserId: number;
}

export interface ResultingUserRequest {
  email: string;
  name: string;
  importedFromFilename?: string;
  integrationsToUse: IntegrationToUseRequest[];
}

export interface EntityValidationErrorResponse {
  errorCode?: EntityValidationErrorResponseErrorCode;
}

export interface CsvImportUserError {
  name?: string;
  email?: string;
  errorFields: CsvImportUserErrorErrorFields[];
}

export interface CsvImportUsersErrorResponse {
  importErrors: CsvImportUserError[];
}

export interface OpsiumUserGroupShortResponse {
  id: number;
  name: string;
}

export interface OpsiumUserProfileInfoResponse {
  id: number;
  email: string;
  name: string;
  profileImageUrl?: string;
  userGroup: OpsiumUserGroupShortResponse;
}

export interface CurrencyResponse {
  code: string;
  displayName: string;
}

export interface WorkScheduleDayResponse {
  dayOfWeek: number;
  startTimeMinutes: number;
  endTimeMinutes: number;
}

export interface WorkScheduleResponse {
  days: WorkScheduleDayResponse[];
}

export interface OrganizationDetailsResponse {
  id: number;
  name: string;
  industry?: string;
  country?: string;
  timezone?: string;
  currency?: CurrencyResponse;
  services: string[];
  workSchedule?: WorkScheduleResponse;
}

export interface OrganizationDefaultsResponse {
  currency: CurrencyResponse;
  organizationRate: number;
  projectRateSource: OrganizationDefaultsResponseProjectRateSource;
  useRateSourceOnProject: OrganizationDefaultsResponseUseRateSourceOnProject;
  assignmentRateSource: OrganizationDefaultsResponseAssignmentRateSource;
}

export interface UpdateWorkScheduleDayRequest {
  dayOfWeek: number;
  startTimeMinutes: number;
  endTimeMinutes: number;
}

export interface UpdateWorkScheduleRequest {
  days: UpdateWorkScheduleDayRequest[];
}

export interface OrganizationLogoPresignedUrlResponse {
  presignedUrl: string;
}

export interface OnboardingStateResponse {
  completed: boolean;
  state?: string;
  flow: OnboardingStateResponseFlow;
}

export interface CreateRequestedIntegrationItemRequest {
  nameOrLink: string;
}

export interface ConnectIntegrationResponse {
  accountId: string;
}

export interface ConnectionStateResponse {
  connected: boolean;
  err?: string;
}

export interface StatusResponse {
  status: boolean;
}

export interface GenerateOAuthUrlResponse {
  url: string;
}

export interface Object {
  [key: string]: any;
}

export interface PreviewClientResponse {
  id: number;
  name: string;
  defaultPaymentTerms: PreviewClientResponseDefaultPaymentTerms;
  email: string;
  connectedIntegrations: PreviewClientResponseConnectedIntegrations[];
  avatarImageUrl: { [key: string]: any };
}

export interface ShortClientResponse {
  id: number;
  name: string;
  avatarImageUrl: string;
  isDeleted: boolean;
}

export interface FindShortClientsFilterRequest {
  searchString?: string;
}

export interface CursorPaginationParametersRequest {
  pageSize: number;
  cursor?: { [key: string]: any };
}

export interface UpsertClientRequestItem {
  name: string;
}

export interface UpdateClientBulkItem {
  id: number;
  name?: string;
}

export interface CsvImportClientError {
  name?: string;
  errorFields: CsvImportClientErrorErrorFields[];
}

export interface CsvImportClientsErrorResponse {
  importErrors: CsvImportClientError[];
}

export interface ResultingClientRequest {
  name: string;
  importedFromFilename?: string;
  integrationsToUse: IntegrationToUseRequest[];
}

export interface CreateIntegrationInfoRequest {
  integrationProviderType: CreateIntegrationInfoRequestIntegrationProviderType;
  connectToLinkId: number;
}

export interface PatchEntityIntegrationsData {
  integrations: CreateIntegrationInfoRequest[];
}

export interface PatchEntityIntegrationsRequest {
  entityId: number;
  integrations: any;
}

export interface GetEndDateOfLastConfirmedAssignmentResponse {
  endDate: { [key: string]: any };
}

export interface ProjectResponse {
  id: number;
  name: string;
  importedFromFilename?: string;
  connectedIntegrations?: ProjectResponseConnectedIntegrations[];
  ignoredIntegrations?: ProjectResponseIgnoredIntegrations[];
  client?: any;
}

export interface OpsiumUserShortResponse {
  id: number;
  email: string;
  name: string;
  isDeleted: boolean;
  profileImageUrl?: string;
}

export interface ProjectSummaryResponse {
  id: number;
  name: string;
  logoUrl: string;
  colorHex: string;
  status: ProjectSummaryResponseStatus;
  tentativeProbability?: { [key: string]: any };
  billingModel?: ProjectSummaryResponseBillingModel;
  manager?: OpsiumUserShortResponse;
  defaultCurrency: CurrencyResponse;
  projectStartDate: string;
  projectEndDate: string;
  nextArchiveDate: string;
  nextUnarchiveDate: string;
  industries: string[];
  connectedIntegrations: ProjectSummaryResponseConnectedIntegrations[];
  client?: any;
}

export interface FindProjectSummariesFilterRequest {
  searchString?: string;
  status?: FindProjectSummariesFilterRequestStatus[];
  tentativeProbabilityMin?: number;
  tentativeProbabilityMax?: number;
  billingModel?: FindProjectSummariesFilterRequestBillingModel[];
  managerId?: number[];
}

export interface InsertProjectRequestItem {
  name: string;
  clientId?: number;
}

export interface UpdateProjectBulkItemRequest {
  id: number;
  name: string;
  clientId?: number;
  ignoredIntegrations?: UpdateProjectBulkItemRequestIgnoredIntegrations[];
  importedFromFilename: { [key: string]: any };
}

export interface CsvImportProjectError {
  name?: string;
  clientName?: string;
  errorFields: CsvImportProjectErrorErrorFields[];
}

export interface CsvImportProjectsErrorResponse {
  importErrors: CsvImportProjectError[];
}

export interface ResultingProjectRequest {
  name: string;
  clientId?: number;
  importedFromFilename?: string;
  integrationsToUse: IntegrationToUseRequest[];
}

export interface CustomAttributeResponse {
  id: number;
  name: string;
  type: CustomAttributeResponseType;
  selectOptions?: string[];
  entityType: CustomAttributeResponseEntityType;
}

export interface AttributeValueResponse {
  attribute: CustomAttributeResponse;
  value?: any;
}

export interface ProjectInfoResponse {
  status: ProjectInfoResponseStatus;
  tentativeProbability: number;
  manager: any;
  projectStartDate: string;
  projectEndDate: string;
  industries: string[];
  customAttributesValues: AttributeValueResponse[];
  colorHex: string;
  name: string;
  client: any;
  logoUrl: string;
  archivedDate: string;
  description: string;
  hasAnyDeletedRelations: boolean;
}

export interface UserRateOptionResponse {
  rate: number;
  source: UserRateOptionResponseSource;
}

export interface UserRateOnProjectResponse {
  user: OpsiumUserShortResponse;
  rate: number;
  hasAssignment: boolean;
  rateSource: UserRateOnProjectResponseRateSource;
  rateOptions: UserRateOptionResponse[];
}

export interface ProjectBillingResponse {
  billingModel: ProjectBillingResponseBillingModel;
  defaultCurrency: CurrencyResponse;
  rateSource: ProjectBillingResponseRateSource;
  flatRate: number;
  budget: number;
  userRates: UserRateOnProjectResponse[];
  hasAnyDeletedRelations: boolean;
}

export interface ConnectedIntegrationResponse {
  id: number;
  name: string;
}

export interface IntegrationInfoResponse {
  integrationProviderType: IntegrationInfoResponseIntegrationProviderType;
  connectedIntegration?: any;
}

export interface IntegrationsResponse {
  integrations: IntegrationInfoResponse[];
}

export interface ProjectFullResponse {
  id: number;
  info: ProjectInfoResponse;
  billing: ProjectBillingResponse;
  integrations: IntegrationsResponse;
  nextArchiveDate: string;
}

export interface CreateProjectResponse {
  projectId: number;
}

export interface CreateAttributeValueRequest {
  attributeId: number;
  value?: any;
}

export interface CreateProjectInfoChangeRequest {
  colorHex?: string;
  clientId?: number;
  name: string;
  status: CreateProjectInfoChangeRequestStatus;
  tentativeProbability?: number;
  managerUserId?: number;
  projectStartDate?: string;
  projectEndDate?: string;
  industries?: string[];
  description?: string;
  customAttributesValues?: CreateAttributeValueRequest[];
}

export interface CreateUserRateOnProjectRequest {
  userId: number;
  rateSource?: CreateUserRateOnProjectRequestRateSource;
  rate?: number;
}

export interface CreateProjectBillingChangeRequest {
  billingModel?: CreateProjectBillingChangeRequestBillingModel;
  defaultCurrencyCode?: string;
  rateSource?: CreateProjectBillingChangeRequestRateSource;
  flatRate?: number;
  budget?: number;
  userRates?: CreateUserRateOnProjectRequest[];
}

export interface CreateProjectIntegrationsChangeRequest {
  integrations: CreateIntegrationInfoRequest[];
}

export interface ProjectImagePresignedUrlResponse {
  presignedUrl: string;
}

export interface ProjectInfoVersionedFieldsResponse {
  status: ProjectInfoVersionedFieldsResponseStatus;
  tentativeProbability: number;
  manager: any;
  projectStartDate: string;
  projectEndDate: string;
  industries: string[];
  customAttributesValues: AttributeValueResponse[];
}

export interface PatchEntityEffect {
  action: PatchEntityEffectAction;
  cutEffectiveStartDate: string;
  cutEffectiveEndDate: string;
}

export interface ProjectInfoSnapshotResponse {
  snapshot: ProjectInfoVersionedFieldsResponse;
  patchEffect: any;
  effectiveStartDate: string;
  effectiveEndDate: string;
}

export interface ProjectInfoListResponse {
  items: ProjectInfoSnapshotResponse[];
}

export interface ProjectBillingSnapshotResponse {
  snapshot: ProjectBillingResponse;
  patchEffect: any;
  effectiveStartDate: string;
  effectiveEndDate: string;
}

export interface ProjectBillingListResponse {
  items: ProjectBillingSnapshotResponse[];
}

export interface ShortProjectResponse {
  id: number;
  name: string;
  logoUrl: string;
  status: ShortProjectResponseStatus;
  colorHex: string;
  nextArchiveDate: string;
  nextUnarchiveDate: string;
}

export interface FindShortProjectsFilterRequest {
  searchString?: string;
  status?: FindShortProjectsFilterRequestStatus[];
}

export interface ProjectChangedFieldResponse {
  fieldName: ProjectChangedFieldResponseFieldName;
  fieldLocalizedName?: { [key: string]: any };
  oldValue?: { [key: string]: any };
  oldValueKey?: ProjectChangedFieldResponseOldValueKey;
  newValue?: { [key: string]: any };
  newValueKey?: ProjectChangedFieldResponseNewValueKey;
  subfieldChanges?: ProjectChangedFieldResponse[];
}

export interface ProjectChangeMetadataResponse {
  changedFields: ProjectChangedFieldResponse[];
  changedByUser: any;
  changedByIntegration: ProjectChangeMetadataResponseChangedByIntegration;
  effectiveStartDate: string;
  effectiveEndDate: string;
  section: ProjectChangeMetadataResponseSection;
  id: number;
  allowedActions: ProjectChangeMetadataResponseAllowedActions[];
  isActive: boolean;
}

export interface ProjectChangesOrder {
  orderBy: ProjectChangesOrderOrderBy;
  orderDirection: ProjectChangesOrderOrderDirection;
}

export interface InvoiceHoursSourceResponse {
  sourceType: InvoiceHoursSourceResponseSourceType;
  hours: number;
  amount: string;
  currencyCode: string;
  averageRate: string;
}

export interface GeneratedInvoiceTeamMemberItemResponse {
  memberId: number;
  username: string;
  hasQuickBooksIntegration: boolean;
  hoursSources: InvoiceHoursSourceResponse[];
}

export interface GeneratedProjectInvoiceResponse {
  projectId: number;
  projectName: string;
  currencyCode: string;
  hasQuickBooksIntegration: boolean;
  members: GeneratedInvoiceTeamMemberItemResponse[];
}

export interface GetGeneratedInvoicesResponse {
  projects: GeneratedProjectInvoiceResponse[];
}

export interface CreateInvoiceItemRequestDto {
  entityId: number;
  entityType: CreateInvoiceItemRequestDtoEntityType;
  quantity: string;
  unitPrice: string;
  amount: string;
}

export interface CreateInvoiceRequestDto {
  projectId: number;
  startDate: string;
  endDate: string;
  currencyCode: string;
  items: CreateInvoiceItemRequestDto[];
}

export interface TeamMemberResponse {
  id: number;
  name: string;
  email: string;
  status: string;
  manager?: string;
  department?: string;
  seniority?: string;
  role?: string;
  capacity?: number;
  toArchiveAt?: string;
  toUnarchiveAt?: string;
}

export interface CapacityIntervalRequest {
  minCapacity: number;
  maxCapacity: number;
}

export interface TeamMembersOrderBy {
  key: string;
  order: TeamMembersOrderByOrder;
}

export interface ShortTeamMemberResponse {
  id: number;
  name: string;
  email: string;
  profileImageUrl: string;
  status: string;
}

export interface FindShortTeamMembersFilterRequest {
  searchString?: string;
  statuses?: FindShortTeamMembersFilterRequestStatuses[];
  isManager?: boolean;
}

export interface DefaultFilterDescriptorResponse {
  id: number;
  name: string;
}

export interface NonPaginatedTeamMemberFiltersResponse {
  departments: DefaultFilterDescriptorResponse;
  roles: DefaultFilterDescriptorResponse;
  seniorities: DefaultFilterDescriptorResponse;
  locations: string[];
}

export interface TeamMemberWithRateResponse {
  user: OpsiumUserShortResponse;
  rateOptions: UserRateOptionResponse[];
}

export interface ProjectBasedRateOptionResponse {
  source: ProjectBasedRateOptionResponseSource;
  rate: number;
}

export interface TeamMemberRatesOnProjectResponse {
  user: OpsiumUserShortResponse;
  rateOptions: UserRateOptionResponse[];
  projectBasedRateOption: ProjectBasedRateOptionResponse;
  currency: CurrencyResponse;
}

export interface DepartmentResponse {
  id: number;
  name: string;
  isDeleted: boolean;
}

export interface SeniorityResponse {
  id: number;
  name: string;
  isDeleted: boolean;
}

export interface EmployeeRoleResponse {
  id: number;
  name: string;
  isDeleted: boolean;
}

export interface TeamMemberInfoResponse {
  name: string;
  invitationStatus: TeamMemberInfoResponseInvitationStatus;
  type: TeamMemberInfoResponseType;
  status: TeamMemberInfoResponseStatus;
  profileImageUrl: { [key: string]: any };
  email: string;
  isManager: boolean;
  manager?: OpsiumUserShortResponse;
  department?: DepartmentResponse;
  seniority?: SeniorityResponse;
  role?: EmployeeRoleResponse;
  tags: string[];
  hasAnyDeletedRelations: boolean;
  country: { [key: string]: any };
  city: { [key: string]: any };
  phoneNumber: string;
  about: string;
}

export interface TeamMemberCapacityResponse {
  onDemand: boolean;
  totalWorkingMinutes?: number;
  billableCapacity?: number;
}

export interface TeamMemberBillingResponse {
  isHourlyRated: boolean;
  internalRateCurrency: CurrencyResponse;
  internalRate?: number;
  externalRateCurrency: any;
  externalRate?: { [key: string]: any };
}

export interface TeamMemberFullResponse {
  id: number;
  toArchiveAt?: { [key: string]: any };
  toUnarchiveAt?: { [key: string]: any };
  displayStatus: TeamMemberFullResponseDisplayStatus;
  info: TeamMemberInfoResponse;
  capacity: TeamMemberCapacityResponse;
  billing: TeamMemberBillingResponse;
  integrations: IntegrationsResponse;
}

export interface TeamMemberUserGroupResponse {
  user: OpsiumUserShortResponse;
  group?: OpsiumUserGroupShortResponse;
  status: TeamMemberUserGroupResponseStatus;
}

export interface UpdateTeamMembersUserGroupsRequestItem {
  teamMemberId: number;
  userGroupId: number;
}

export interface TeamMemberAvatarPresignedUrlResponse {
  presignedUrl: string;
}

export interface TeamLocationsResponse {
  locations: string[];
}

export interface TeamMemberChangeResponse {
  [key: string]: any;
}

export interface TeamMemberChangeConflictResponse {
  change: TeamMemberChangeResponse;
  description: string;
}

export interface TeamMemberChangeMetadataResponse {
  id: number;
  changedByUser: any;
  changedByIntegration: TeamMemberChangeMetadataResponseChangedByIntegration;
  effectiveStartDate: string;
  effectiveEndDate: string;
  deleteOnlyAllowed: boolean;
  disableDeletion: boolean;
  section: TeamMemberChangeMetadataResponseSection;
  isActive: boolean;
}

export interface TeamMemberChangeConflictOnDeleteResponse {
  previousStateDelta: any;
  nextStateDelta: any;
}

export interface AvailableArchivationDateResponse {
  availableArchivationDate: string;
}

export interface AvailableUnarchivationDateResponse {
  availableUnarchivationDate: string;
}

export interface TeamMemberChangedFieldResponse {
  fieldName: TeamMemberChangedFieldResponseFieldName;
  fieldLocalizedName?: { [key: string]: any };
  oldValue?: { [key: string]: any };
  oldValueKey?: TeamMemberChangedFieldResponseOldValueKey;
  newValue?: { [key: string]: any };
  newValueKey?: TeamMemberChangedFieldResponseNewValueKey;
  subfieldChanges?: TeamMemberChangedFieldResponse[];
}

export interface PlannerUserStateChangeResponse {
  effectiveStartDate: string;
  effectiveEndDate?: string;
  displayStatus: PlannerUserStateChangeResponseDisplayStatus;
  onDemand: boolean;
  billableCapacityPercent: number;
  workingMinutesPerDay: number;
  salary: number;
  salaryCurrency: any;
  externalRate?: number;
  isHourlyRated: boolean;
  department?: any;
  role?: any;
  seniority?: any;
  city?: string;
  country?: string;
  manager?: any;
  isManager: boolean;
  changedFields: TeamMemberChangedFieldResponse[];
}

export interface DailyUtilizationResponse {
  date: string;
  assigned: number;
  capacity: number;
  percent: number;
}

export interface AssignmentProjectResponse {
  id: number;
  name: string;
  colorHex: string;
}

export interface AssignmentResponse {
  id: number;
  startDate: string;
  endDate: string;
  status: AssignmentResponseStatus;
  doSkipWeekdays: boolean;
  isBillable: boolean;
  label: string;
  minutesPerDay: number;
  note: string;
  isBackgroundWork: boolean;
  rateSource: AssignmentResponseRateSource;
  customRate?: { [key: string]: any };
  externalRate?: { [key: string]: any };
  rateCurrency?: any;
  project: AssignmentProjectResponse;
  syncToken: string;
}

export interface DateRangeResponse {
  startDate: string;
  endDate: string;
}

export interface PlannerAssignmentResponse {
  assignment: AssignmentResponse;
  overlapsSameProject: boolean;
  overlapsAssignmentIds: number[];
  activePeriods: DateRangeResponse[];
}

export interface PlannerMemberResponse {
  user: OpsiumUserShortResponse;
  stateChanges: PlannerUserStateChangeResponse[];
  utilizationByDate: DailyUtilizationResponse[];
  assignments: PlannerAssignmentResponse[];
}

export interface GetAssignmentsForPlannerFilters {
  startDate: string;
  endDate: string;
  userIds?: number[];
  projectIds?: number[];
  clientIds?: number[];
  departmentIds?: number[];
  roleIds?: number[];
  seniorityIds?: number[];
  locationFilters?: string[];
  statuses?: GetAssignmentsForPlannerFiltersStatuses[];
  projectStatuses?: GetAssignmentsForPlannerFiltersProjectStatuses[];
  probabilityMin?: number;
  probabilityMax?: number;
  isBillable?: boolean;
  searchQuery?: string;
}

export interface PlannerDepartmentResponse {
  department: any;
  members: PlannerMemberResponse[];
  utilizationByDate: DailyUtilizationResponse[];
}

export interface dd6cbcba81a03cb447ec4 {
  pageSize: number;
  cursor?: string;
}

export interface PlannerProjectResponse {
  project: AssignmentProjectResponse;
  members: PlannerMemberResponse[];
  utilizationByDate: DailyUtilizationResponse[];
}

export interface ValidateAssignmentResponse {
  overlapping: boolean;
}

export interface AvailableSettingTypesResponse {
  types: AvailableSettingTypesResponseTypes[];
}

export interface DepartmentWithMemberCountResponse {
  id: number;
  name: string;
  memberCount: number;
}

export interface UpdateDepartmentRequestItem {
  id?: number;
  name: string;
}

export interface SeniorityWithMemberCountResponse {
  id: number;
  name: string;
  memberCount: number;
}

export interface UpsertSeniorityRequestItem {
  id?: number;
  name: string;
}

export interface EmployeeRolesWithMemberCountResponse {
  id: number;
  name: string;
  memberCount: number;
}

export interface UpsertEmployeeRolesRequestItem {
  id?: number;
  name: string;
}

export interface OpsiumUserGroupPoliciesResponse {
  id: number;
  name: string;
  policies: OpsiumUserGroupPoliciesResponsePolicies[];
}

export interface UpdateUserGroupPoliciesRequestItem {
  id: number;
  policies: UpdateUserGroupPoliciesRequestItemPolicies[];
}

export interface EntityIntegrationLinkShortResponse {
  id: number;
  name: string;
}

export interface IntegrationLinksResponse {
  integration: IntegrationLinksResponseIntegration;
  links: EntityIntegrationLinkShortResponse[];
}
